import { WorkListItem } from './WorkListItem'
import { useWorks, UseWorksOptions } from '../lib/apiClient'

interface WorkListProps {
  showIsLoading?: boolean;
  showZeroCountMessage?: boolean;
  orphanWorksOnly?: boolean;
}

export const WorkList: React.FC<WorkListProps> = ({
  showIsLoading,
  showZeroCountMessage,
  orphanWorksOnly,
}) => {
  const opts: UseWorksOptions = {}
  if (orphanWorksOnly) {
    opts.exhibitionId = null
  }
  const { data: works, isLoading, isError } = useWorks(opts)
  return (
    <div>
      {showIsLoading && isLoading && <p>Loading...</p>}
      {isError && <p>Error!</p>}
      {showZeroCountMessage && works?.length === 0 && <p>No current exhibitions.</p>}
      {
        works?.map((w) => (
          <WorkListItem key={w.id} work={w} />
        ))
      }
    </div>
  )
}
